export enum BarcodeError {
  CANCELLED = 'Scanning cancelled',
  CANCELLED_ANDROID = "Couldn't scan because the process was cancelled.",
  CAMERA_PERMISSION_DENIED = 'Camera access denied',
  CAMERA_PERMISSION_DENIED_ANDROID = "Couldn't scan because camera access wasn't provided. Check your camera permissions and try again.",
  CANCELLED_IOS = "OS-PLUG-BARC-0006"
}
